/* eslint-disable */

/**
 * List of ineligibility reasons for check-in.
 */
export enum FinnairCheckInEligibilityReason {
  NOT_ELIGIBLE_EMAIL_MISSING = 'NOT_ELIGIBLE_EMAIL_MISSING',
  NOT_ELIGIBLE_SSR = 'NOT_ELIGIBLE_SSR',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE'
}

